import React, { useState } from 'react';
import Navbar from '../../components/common/Navbar/Navbar';
import Footer from '../../components/common/Footer/Footer';
import logo from '../../assets/Avothar-black-logo.png';
import Bannar from '../../components/common/Bannar/Bannar';
import bannarImg from '../../assets/banner/about-img.gif';
import ripped from '../../assets/farm/ripped-paper-header-1.png';
import '../../styles/contact.css';
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

const Contact = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone_no, setPhoneNo] = useState('');
  const [firstNameError, setFirstNameError] = useState('');
  const [SecondNameError, setScondNameError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [emailError, setEmailError] = useState('');

  const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:5000";

    console.log("url",baseUrl);
  

  const validatefirstName = (name) => {  
    const nameRegex = /^[A-Za-z\s]+$/;
    if (!name.match(nameRegex)) {
      setFirstNameError('Name should only contain letters and spaces.');
    } else {
      setFirstNameError('');
    }
  };

  const validateSecondName = (name) => {  
    const nameRegex = /^[A-Za-z\s]+$/;
    if (!name.match(nameRegex)) {
      setScondNameError('Name should only contain letters and spaces.');
    } else {
      setScondNameError('');
    }
  };


  const validatePhone = (phone) => {
    const phoneRegex = /^[0-9]{10}$/;
    if (!phone.match(phoneRegex)) {
      setPhoneError('Phone number must be exactly 10 digits.');
    } else {
      setPhoneError('');
    }
  };

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!email.match(emailRegex)) {
      setEmailError('Enter a valid email address.');
    } else {
      setEmailError('');
    }
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  const message = document.getElementById('message').value;

  // EmailJS payload
  const emailJsData = {
    user_name: `${firstName} ${lastName}`,
    user_email: email,
    phone: phone_no,
    message,
  };

  // MongoDB payload
  const formData = {
    firstName,
    lastName,
    email,
    phone: phone_no,
    message,
  };

  const serviceID = 'service_bacqo1s';
  const adminTemplateID = 'template_ffsklxh';
  const userTemplateID = 'template_sdmj0y4';
  const publicKey = 'kC7mU2fvX2_nIkxLl';

  // ✅ Save to DB first
  await axios.post(`${baseUrl}/api/contact`, formData)
    .then(() => {
      toast.success('✅ Contact saved to database');

      // ✅ Send mail to admin
      emailjs.send(serviceID, adminTemplateID, emailJsData, publicKey)
        .then(() => {
          toast.success('📬 Mail sent to admin');
        })
        .catch(() => {
          toast.error('⚠️ Failed to send mail to admin');
        });

      // ✅ Send thank-you mail to user
      emailjs.send(serviceID, userTemplateID, emailJsData, publicKey)
        .then(() => {
          toast.success('🙌 Thank-you email sent to you!');
        })
        .catch(() => {
          toast.error('⚠️ Thank-you email failed');
        });

      // Reset fields
      setFirstName('');
      setLastName('');
      setEmail('');
      setPhoneNo('');
      document.getElementById('message').value = '';
    })
    .catch((err) => {
      console.error('DB Save Error:', err);
      toast.error('❌ Failed to save contact to database');
    });
};

  return (
    <div className="bg-white">
      <Navbar position="static" logo={logo} color="dark" buttonColor="light" navColor="black" />
      <Bannar img={bannarImg} name="Contact Us" />

      <div className="ripped-paper-base" style={{
        backgroundImage: `url(${ripped})`,
        height: '2.6vh',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        transform: 'rotate(180deg)',
        backgroundSize: 'cover',
        position: 'relative',
        bottom: 15,
        left: 0,
      }}></div>

      <section className="elementor-section">
        <div className="container-fluid ">
          <h1 className="banner-font text-center mb-3">Visit Our Location</h1>
          <p className="banner-font text-center mb-4" style={{ letterSpacing: 1.5 }}>
            Easily accessible via Fern Hill Road, our Kodai Agriorg is located at the heart of Kodaikanal...
          </p>
          <div className="img-thumbnail">
            <iframe loading="lazy"
              src="https://maps.google.com/maps?q=%233%20%2C%20Sornam%20Complex%2C%20Fern%20Hill%20Rd%2C%20Kodaikanal%2C%20Tamil%20Nadu%20624101&#038;t=m&#038;z=10&#038;output=embed&#038;iwloc=near"
              title="Map"
              aria-label="Map"
              width="100%" height="350px" frameBorder="0">
            </iframe>
          </div>
        </div>
      </section>

      <div className="ripped-paper-base" style={{
        backgroundImage: `url(${ripped})`,
        height: '2.6vh',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        position: 'relative',
        bottom: -15,
        left: 0,
        zIndex: 10,
      }}></div>

      <section>
        <div className="row tour-image pt-3" style={{ backgroundColor: 'rgba(0, 0, 0, 0.9)' }}>
          <div className="col-lg-5">
            <div className='mt-4 d-flex justify-content-center text-white'>
              <h1 className='banner-font'>Contact Form</h1>
            </div>

            <form className="custom-form" onSubmit={handleSubmit}>
              <div>
                <label htmlFor="name" className='banner-font'>Name <span className="text-danger">*</span></label><br />
                <div className="row">
                  <div className="col-md-6 banner-font">
                    <input
                      type="text"
                      id="firstName"
                      placeholder="First Name"
                      value={firstName}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^A-Za-z\s]/g, '');
                        setFirstName(value);
                        validatefirstName(value);
                      }}
                      className={!firstNameError ? 'valid' : 'invalid'}
                      required
                    />
                    {firstNameError && <div className="error-msg banner-font pt-2">{firstNameError}</div>}
                  </div>
                  <div className="col-md-6 banner-font">
                    <input
                      type="text"
                      id="lastName"
                      placeholder="Last Name"
                      value={lastName}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^A-Za-z\s]/g, '');
                        setLastName(value);
                        validateSecondName(value);
                      }}
                      className={!SecondNameError ? 'valid' : 'invalid'}
                      required
                    />
                    {SecondNameError && <div className="error-msg banner-font pt-2">{SecondNameError}</div>}
                  </div>
                </div>
              </div>

              <div className='banner-font py-3'>
                <label htmlFor="email" className='banner-font'>Email <span className="text-danger">*</span></label><br />
                <input
                  type="email"
                  id="email"
                  placeholder="Your Email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    validateEmail(e.target.value);
                  }}
                  className={!emailError ? 'valid' : 'invalid'}
                  required
                />
                {emailError && <div className="error-msg banner-font pt-2">{emailError}</div>}
              </div>

              <div className='py-3'>
                <label htmlFor="phoneNo" className='banner-font'>Phone Number <span className="text-danger">*</span></label><br />
                <input
                  type="text"
                  id="phoneNo"
                  placeholder="10-digit Phone Number"
                  value={phone_no   }
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, '');
                    if (value.length <= 10) {
                      setPhoneNo(value);
                      validatePhone(value);
                    }
                  }}
                  className={!phoneError ? 'valid banner-font' : 'invalid banner-font'}
                  required
                />
                {phoneError && <div className="error-msg banner-font pt-2">{phoneError}</div>}
              </div>

              <div>
                <label htmlFor="message" className='banner-font'>Message <span className="text-danger">*</span></label><br />
                <textarea
                  id="message"
                  className='valid banner-font'
                  rows={6}
                  placeholder="Your message here..."
                  required
                ></textarea>
              </div>

              <div className="form-submit banner-font ">
                <button type="submit">Submit</button>
              </div>
            </form>
          </div>

          {/* Right Column */}
          <div className="col-lg-7 pt-4 p-5 text-white marigin-auto">
            <div className="mb-5">
              <h1 className='banner-font mb-4 text-center'>Visit Us</h1>
              <h5 className='banner-font text-center' style={{ letterSpacing: 2, wordSpacing: 2 }}>WE’D LOVE TO HEAR WHAT YOU THINK</h5>
            </div>
            <div className="banner-font" style={{ marginBottom: 75 }}>
              <p className="banner-font d-flex align-items-center" style={{ letterSpacing: 2, wordSpacing: 2 }}>
                <span className='me-3 text-success fs-3'>✆</span> Call/Whatsapp Us at:</p>
              <p className='banner-font' style={{ marginLeft: 44, letterSpacing: 2, wordSpacing: 2 }}>Kodai Agriorg Sales: +91 98845 90109</p>
              <p className='banner-font' style={{ letterSpacing: 2, wordSpacing: 2 }}><img className=" emoji" src="https://s.w.org/images/core/emoji/14.0.0/svg/2709.svg" alt="✉" style={{ width: 24, marginRight: 19 }} />Email Us at:</p>
              <p><a className='text-secondary' style={{ marginLeft: 44, letterSpacing: 2 }} href="mailto:info@kodaiagriorg.com">info@kodaiagriorg.com</a></p>
            </div>
            <div className="banner-font">
              <strong><p className="fs-5 banner-font" style={{ letterSpacing: 2, wordSpacing: 2 }}>Our Address</p></strong>
              <p className="banner-font" style={{ letterSpacing: 2, wordSpacing: 2 }}>KODAI AGRIORG PRIVATE LIMITED</p>
              <p className="banner-font" style={{ letterSpacing: 2, wordSpacing: 2 }}>3/2-2, Lloyds Road, KODAIKANAL, Dindigul</p>
              <p className="banner-font" style={{ letterSpacing: 2, wordSpacing: 2 }}>Tamil Nadu, 624101.</p>
            </div>
          </div>
        </div>
      </section>

      <div className='ripped-paper-base' style={{
        backgroundImage: `url(${ripped})`,
        height: "2.6vh",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        transform: "rotate(180deg)",
        backgroundSize: "cover",
        position: "relative",
        bottom: 15,
        left: 0
      }}></div>

      <ToastContainer position="top-right" autoClose={3000} />
      <Footer />
    </div>
  );
};

export default Contact;
